<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<vxe-grid ref="distributionprofitprice" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '分销价格',
				modal_width: 1200,
				modal_height: 800,
				loading:false,
				list_formConfig: [{
						field: 'distribution',
						title: '分销商',
						resetValue: "固万基",
						itemRender: {
							name: '$select',
							defaultValue: "固万基",
							props: {
								emptyoption: false,
								selectoptions: [{
									label: "固万基",
									value: "固万基",
								}],
							}
						}
					},
					{
						field: 'code',
						title: '商品编码',
						itemRender: {
							name: '$input',
							props: {}
						}
					}
				],
				list_columns: [{
						field: 'code',
						title: '商品编码',
						fixed:'left',
						width:100,
					},
					{
						field: 'name',
						title: '商品名称',
						width:100,
					},
					{
						field: 'model',
						title: '规格型号',
						width:100,
					},
					{
						field: 'weight',
						title: '重量(g)',
						width:100,
					},
					{
						field: 'recommendlevel',
						title: '采购推荐等级',
						width:100,
					},
					{
						field: 'tmprice',
						title: '天猫价格',
						width:100,
					},
					{
						field: 'tmprice11',
						title: '天猫价格1.1',
						width:100,
					},
					{
						field: 'tmprice04',
						title: '天猫价格0.4',
						width:100,
					},
					{
						field: 'suppliercost',
						title: '进价',
						width:100,
					},
					{
						field: 'value',
						title: '货值(1斤)',
						width:100,
					},
					{
						field: 'expresscost',
						title: '到仓运费',
						width:100,
					},
					{
						field: 'adjustcost',
						title: '到仓进价',
						width:100,
					},
					{
						field: 'loss',
						title: '损耗',
						width:100,
					},
					{
						field: 'price',
						title: '分销价格',
						fixed:'right',
						width:100,
					},
					{
						field: 'distributionprofitratio',
						title: '对方毛利率',
						fixed:'right',
						width:100,
					},
					{
						field: 'profitratio',
						title: '我方毛利率',
						fixed:'right',
						width:100,
					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.proxyConfig.autoLoad = false
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '同步库存',
					status: 'danger',
					code: 'updatestock'
				}]
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 100,
					pageSizes: [100, 500, 1000,20000],
				}
			},
			list(page,updateForm,other) {
				return new Promise((resolve,reject) => {
					this.$api.goods.getdistributionprice({
						...page,
						...updateForm,
						...other,
					}).then((res)=>{
						resolve(res)
					},()=>{
						reject()
					})
				})
			},
			updatestock(){
				// let ProxyInfo = this.$refs.distributionprofitprice.getProxyInfo()
				// let distribution = ProxyInfo.form.distribution
				this.$confirm('是否确认同步', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.goods.updatestock().then(() => {
						this.loading = false
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			customreload(){
				this.$refs.distributionprofitprice.commitProxy('query')
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>